import { connect } from 'react-redux';
import { setAdvancedSearchFilters, setSearchItemDetails } from 'redux-core/header/actions';

const mapDispatchToProps = {
  setAdvancedSearchFilters,
  setSearchItemDetails,
};

export default connect(undefined, mapDispatchToProps);
